﻿<aside aria-label="Side Effect Editor">
    <h2>Workflow Actions</h2>
    <div class="grid-x">
        <div class="cell small-12">
            <label>
                Transition Name:
                <input name="transitionName" class="no-margin" type="text" placeholder="Add Name"
                       [(ngModel)]="transition.name" (ngModelChange)="transitionNameChange($event)"
                       (focus)="preEditTransitionName=transition.name"
                       [ngClass]="{'is-invalid-input':showDuplicateNameWarning}">
            </label>
        </div>
        <div [ngClass]="{'hide': !showDuplicateNameWarning}" class="cell small-12 small-font-size red">
            Duplicate Transition name, please change the transition name!
        </div>
    </div>
    <div class="grid-x">
        <div class="cell small-12">
            Insert New Form:
        </div>
        <div class="cell small-4 padding-right">
            <select [(ngModel)]="newFormType">
                <option *ngFor="let opt of insertableStateTypes" [ngValue]="opt.type">
                    {{opt.description}}
                </option>
            </select>
        </div>
        <div class="cell small-5">
            <div class="checkbox">
                <input class="show-for-sr" id="cloneForm" type="checkbox" [(ngModel)]="clonePreceding" />
                <label for="cloneForm">
                    Clone Preceding Form: <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
                </label>
            </div>
        </div>
        <div class="cell small-3 padding-left">
            <button (click)="insertForm()" class="button hollow">Insert</button>
        </div>
    </div>
    <button class="button hollow float-right margin-top" (click)="addSideEffect()">Add Workflow Action</button>
    <div *ngIf="transition">
        <hr />
        <h3>Actions Applied</h3>
        <div *ngIf="sideEffectList && sideEffectList.length > 0"
             class="grid-x grid-padding-x grid-padding-y small-up-5 expanded">
            <div *ngFor="let se of sideEffectList; let i = index; let isLast = last" class="cell">
                <button aria-label="Action item" class="card-fixed-height-small" [ngSwitch]="se.implementationType"
                        (click)="setSelectedSideEffect(i)" [ngClass]="{'active': i === selectedSideEffectIndex}">
					<ng-container [ngSwitch]="se.implementationType">
						<svg-icon icon="icon-database" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.SaveToDatabase">
						</svg-icon>
						<svg-icon icon="icon-download" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.LoadFromDatabase">
						</svg-icon>
						<svg-icon icon="icon-mail" class="dark-gray float-center" *ngSwitchCase="sideEffects.SendEmail">
						</svg-icon>
						<svg-icon icon="icon-rules-config" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.TransformContext">
						</svg-icon>
						<svg-icon icon="icon-pause" class="dark-gray float-center" *ngSwitchCase="sideEffects.hold">
						</svg-icon>
						<svg-icon icon="icon-group" class="dark-gray float-center" *ngSwitchCase="sideEffects.AssignGroup">
						</svg-icon>
						<svg-icon icon="icon-torso" class="dark-gray float-center" *ngSwitchCase="sideEffects.AssignUser">
						</svg-icon>
						<svg-icon icon="icon-sitemap" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.StartWorkflow">
						</svg-icon>
						<svg-icon icon="icon-arrows-out" title="Kick off another work flow" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.InvokeTransitionOnOtherWorkflow">
						</svg-icon>
						<svg-icon icon="icon-sitemap" title="Kick off another work flow" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.StartAnotherWorkflow">
						</svg-icon>
						<svg-icon icon="icon-sitemap" title="Modify other work flow context" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.ModifyOtherWorkFlowContext">
						</svg-icon>
						<svg-icon icon="icon-view" class="dark-gray float-center" *ngSwitchCase="sideEffects.ReviewTasks">
						</svg-icon>
						<svg-icon icon="icon-checkbox" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.CompleteWorkItem">
						</svg-icon>
						<svg-icon icon="icon-reply" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.ReturnWorkItem">
						</svg-icon>
						<svg-icon icon="icon-upload" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.CommitDocuments">
						</svg-icon>
						<svg-icon icon="icon-gis-map" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.GenerateIdentifier">
						</svg-icon>
						<svg-icon icon="icon-view" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.AssignToScanning">
						</svg-icon>
						<svg-icon icon="icon-data-lookup" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.LoadContactData">
						</svg-icon>
						<svg-icon icon="icon-chief-signature" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.GenerateWellApi">
						</svg-icon>
						<svg-icon icon="icon-pause" class="dark-gray float-center" *ngSwitchCase="sideEffects.CancelPermit">
						</svg-icon>
						<svg-icon icon="icon-gis-map" class="dark-gray float-center"
								  *ngSwitchCase="sideEffects.SetDueDtAndApproveDt">
						</svg-icon>
						<svg-icon icon="icon-help" class="dark-gray float-center" *ngSwitchDefault>
						</svg-icon>
					</ng-container>                    
                    <div class="card-body">
                        <div class="card-body-label" title="{{se.label}}">{{se.label}}</div>
                    </div>
                </button>
                <button class="card-fixed-height-small-delete" title="Delete action item" (click)="deleteSideEffect(i)"
                        attr.aria-label="Delete Action Item {{se.label}}">
                    <span class="show-for-sr">Delete Action Item {{se.label}}</span>
                    <svg-icon aria-hidden="true" icon="icon-trash" class="tiny dark-gray"></svg-icon>
                </button>
                <ng-container *ngIf="i !== 0">
                    <a title="Move Action Earlier" class="large-font-size" (click)="makeEarlier(i)"
                       attr.aria-label="Move {{se.label}} Earlier">&laquo;</a>
                    <a *ngIf="!isLast" title="Move Action Later" class="large-font-size" (click)="makeLater(i)"
                       attr.aria-label="Move {{se.label}} Later">&raquo;</a>
                </ng-container>
                <!-- <button *ngIf="i !== 0" class="card-fixed-height-small" title="Move Action Earlier" (click)="makeEarlier(i)" attr.aria-label="Move {{se.label}} Earlier">&laquo;</button>
                <button *ngIf="i !== 0" class="card-fixed-height-small" title="Move Action Later" (click)="makeLater(i)" attr.aria-label="Move {{se.label}} Later">&raquo;</button> -->
            </div>
        </div>
    </div>
    <div *ngIf="showConfigurationEditor">
        <hr>
        <h4>Action Configuration</h4>
        <form novalidate>
            <div class="grid-x">
                <div class="cell small-12">
                    <label>
                        Label:
                        <input name="sideEffectLabel" type="text" placeholder="Add Label" data-transition-key="label"
                               [(ngModel)]="selectedSideEffect.label">
                    </label>
                </div>
                <div class="cell small-12">
                    <label>
                        Workflow Action Type:
                        <select name="sideEffectIType" [(ngModel)]="selectedSideEffect.implementationType"
                                (ngModelChange)="implementationTypeChanged()">
                            <option *ngFor="let seType of selSideEffectTypeOptions" [value]="seType.id">
                                {{ seType.text }}
                            </option>
                        </select>
                    </label>
                </div>
                <div class="cell small-12">
                    <div class="tiny">
                        <label class="inline vertical-align-middle minor-margin-right" for="runOnce">Run only once:</label>
                        <input class="no-margin-bottom vertical-align-middle" type="checkbox" [checked]="selectedSideEffect.runOnce" id="runOnce"
                               (change)="runOnceChanged($event.target.checked)" />
                    </div>
                </div>
                <div class="cell small-11">
                    <div>
                        <label>Run Condition</label>
                    </div>
                </div>
                <div class="cell small-1 text-align-right">
                    <button (click)="runConditionExpanded = !runConditionExpanded" *ngIf="runConditionExpanded">
                        <svg-icon icon="icon-caret-down" class="small black"></svg-icon>
                    </button>
                    <button (click)="runConditionExpanded = !runConditionExpanded" *ngIf="!runConditionExpanded">
                        <svg-icon icon="icon-caret-right" class="small black"></svg-icon>
                    </button>
                </div>
                <div class="cell small-12" [ngStyle]="{ 'display': runConditionExpanded ? 'inherit' : 'none' }">
                    <rules-editor placeholder="Add Run Condition" data-transition-key="Run Condition" name="runConditionText" [type]="'Run Condition'" [expression]="selectedSideEffect.runCondition" (updateRule)="runConditionRuleChanged($event)">
                    </rules-editor>
                </div>
                <div class="cell small-12" [ngStyle]="{ 'display': runConditionExpanded ? 'inherit' : 'none' }">
                    Expression must be sucessfully tested to update the run condition!
                </div>
            </div>
        </form>
        <hr class="horizontal-rule" />
    </div>
    <ng-container #portal></ng-container>
</aside>
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
